import "./Contact.module.css";
import Encabezado from "@/reusable_sections/Header";
import AgendarEvaluacion from "./sections/AgendarEvaluacion";
import CanalesDirectos from "./sections/CanalesDirectos";
import PieDePagina from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Encabezado />
      <AgendarEvaluacion />
      <CanalesDirectos />
      <PieDePagina />
    </div>;
}